// extracted by mini-css-extract-plugin
export default {"button":"button__3zJkv","button_full":"button_full__21D_O","button_disabled":"button_disabled__3nRYz","button__spinner":"button__spinner__2t8x1"};